import {isMapPolygonFillVisible} from '@components/openstreetmap/constants/map-polygon-fill-visibility.state';

/**
 * Draws one geojson-vt polygon onto a canvas tile context (polygon type === 3 in vt).
 */
export function paintVtPolygonOnCanvasTile(
  ctx: CanvasRenderingContext2D,
  feature: any,
  scale: number,
  thinStrokeForLargeDataset: boolean,
  fallbackStroke: string,
  fallbackFill: string,
): void {
  const tags = feature.tags || {};
  ctx.strokeStyle = tags.strokeColor ?? fallbackStroke;
  ctx.fillStyle = tags.fillColor ?? fallbackFill;
  ctx.lineWidth = thinStrokeForLargeDataset
    ? Math.max(0.5, 0.9)
    : Math.max(0.75, tags.strokeWidth ?? 2);

  const geometry = feature.geometry;
  if (feature.type !== 3 || !geometry?.length) return;

  ctx.beginPath();
  for (let ri = 0; ri < geometry.length; ri++) {
    const ring = geometry[ri];
    if (!ring?.length) continue;
    for (let j = 0; j < ring.length; j++) {
      const p = ring[j];
      const x = p[0] * scale;
      const y = p[1] * scale;
      if (j === 0) {
        ctx.moveTo(x, y);
      } else {
        ctx.lineTo(x, y);
      }
    }
    ctx.closePath();
  }
  const fillOpacity = typeof tags.fillOpacity === 'number' ? tags.fillOpacity : 0.8;
  if (isMapPolygonFillVisible()) {
    ctx.globalAlpha = fillOpacity;
    ctx.fill();
    ctx.globalAlpha = 1;
  }
  ctx.stroke();
}
